import { createContext, useContext, useState } from 'react'

const AppSuccessContext = createContext<any>(null)

export const AppSuccessMessageProvider = ({ children }: { children: React.ReactNode }) => {
  const [appSuccessMessage, setAppSuccessMessage] = useState<string>('')

  const setSuccessMessage = (message: string) => {
    setAppSuccessMessage(() => message)
  }

  return (
    <AppSuccessContext.Provider value={{ appSuccessMessage, setSuccessMessage }}>
      {children}
    </AppSuccessContext.Provider>
  )
}

export const useAppSuccessMessageContext = () => useContext<IUseData>(AppSuccessContext)

interface IUseData {
  appSuccessMessage: string
  setSuccessMessage: (message: string) => void
}
